import {RootState} from "@service/store/types/RootState";
import Vue from 'vue';

export const state: RootState = {
    isLoading: false,
    session: Vue.observable({
        userId: -1,
        sessionId: '',
        refreshToken: '',
        language: '',
        roleId: '',
        backend: ''
    }),
    afterLoginPath: '',
    timeZoneOffset: null,
    selectedTimeZoneOffset: null,
    timeZoneNames: {},
    showChat: false,
    showAnonymAuth: false,
    profileObserver: null,
    meetingsCheckingIntervalId: null,
    configurationReloadIntervalId: null,
    isTokenUpdating: false,
    screenNameData: null,
    webConferenceRecordingEventId: null,
    initErrors: [],
    initializing: false,
    isOnEditing: false,
    // TODO: delete this please. It doesn't need to store there
    currentUserCompanyId: ""
}
